import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';

/** Purpose: Renders received-records summary and reopen request panel. Inputs: section props. Output: React render output (JSX). */
export default function ReceivedAndReopenSection({
  request,
  showReopenPanel,
  setShowReopenPanel,
  reopenMessage,
  setReopenMessage,
  reopenSendFollowUp,
  setReopenSendFollowUp,
  reopenError,
  reopenLoading,
  onReopen
}) {
  return (
    <>
      {(request.receivedRecords?.length > 0 || ['RECEIVED', 'PARTIALLY_RECEIVED'].includes(request.status)) && (
        <div className="border-t border-slate-200 pt-6">
          <h4 className="font-medium text-slate-900 mb-3">Received Records</h4>
          {request.receivedRecords?.length > 0 ? (
            <div className="flex flex-wrap gap-2">
              {request.receivedRecords.map(record => (
                <span key={record.id} className="px-3 py-1 bg-green-50 text-green-700 text-sm rounded-full">
                  {record.title}
                </span>
              ))}
            </div>
          ) : (
            <p className="text-sm text-slate-600">
              Records marked as received, but none are linked yet.
            </p>
          )}
        </div>
      )}

      {request.status === 'RECEIVED' && (
        <div className="border-t border-slate-200 pt-6">
          <div className="p-4 rounded-lg bg-amber-50 border border-amber-200">
            <div className="flex items-center justify-between gap-3">
              <div className="flex items-start gap-3">
                <AlertCircle className="w-5 h-5 text-amber-600 mt-0.5" />
                <div>
                  <p className="font-medium text-slate-900">Need additional records?</p>
                  <p className="text-sm text-slate-700">
                    Reopen this request and optionally send a follow-up email to the provider.
                  </p>
                </div>
              </div>
              <button
                onClick={() => setShowReopenPanel(!showReopenPanel)}
                className="px-3 py-2 bg-amber-600 text-white rounded-lg text-sm hover:bg-amber-700 whitespace-nowrap"
              >
                {showReopenPanel ? 'Cancel' : 'Reopen Request'}
              </button>
            </div>

            {showReopenPanel && (
              <div className="mt-4 pt-4 border-t border-amber-200 space-y-3">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">
                    Message to provider (optional)
                  </label>
                  <textarea
                    value={reopenMessage}
                    onChange={(e) => setReopenMessage(e.target.value)}
                    rows={3}
                    className="w-full px-3 py-2 border border-slate-300 rounded-lg text-sm"
                    placeholder="e.g., We still need imaging reports from January 2025..."
                  />
                </div>
                {request.email && (
                  <label className="flex items-center gap-2 text-sm text-slate-700">
                    <input
                      type="checkbox"
                      checked={reopenSendFollowUp}
                      onChange={(e) => setReopenSendFollowUp(e.target.checked)}
                      className="rounded border-slate-300"
                    />
                    Send follow-up email to {request.email}
                  </label>
                )}
                {reopenError && (
                  <p className="text-xs text-red-600">{reopenError}</p>
                )}
                <div className="flex justify-end">
                  <button
                    onClick={onReopen}
                    disabled={reopenLoading}
                    className="px-4 py-2 bg-amber-600 text-white rounded-lg text-sm hover:bg-amber-700 disabled:opacity-50 inline-flex items-center gap-2"
                  >
                    {reopenLoading && <Loader2 className="w-4 h-4 animate-spin" />}
                    {reopenSendFollowUp && request.email ? 'Reopen & Send Follow-up' : 'Reopen Request'}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}
